'use client';

import { Textarea } from '@apex-titan/ui';
import { type ComponentProps } from 'react';
import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from 'react-hook-form';

type FormTextareaProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<
    ComponentProps<typeof Textarea>,
    'value' | 'onChange' | 'name' | 'defaultValue'
  >;

export function FormTextarea<T extends FieldValues>({
  name,
  control,
  rules,
  defaultValue,
  shouldUnregister,
  ...textareaProps
}: FormTextareaProps<T>) {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });
  return (
    <Textarea
      {...textareaProps}
      {...field}
      value={field.value ?? ''}
      errorMessage={fieldState.error?.message}
    />
  );
}
